import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Criterials from '../general/criterials';
import Unit from '../general/unit';
import Options from '../general/options';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import {Table, Button} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';

var Config = require('../../../config');

class LockUnitsForm extends Component{
	constructor(props){
		super(props);

		this.getOption = this.getOption.bind(this);
		this.getData = this.getData.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.selectAll = this.selectAll.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.printFolioPDF = this.printFolioPDF.bind(this);
		this.getList = this.getList.bind(this);
		this.selectComponent = this.selectComponent.bind(this);
		this.addUnit = this.addUnit.bind(this);
		this.deleteFromList = this.deleteFromList.bind(this);


		this.state = {
			option:"Unit",
			unit_number:"",
			code_component_list:[],
			code_component:"",
			isLoading:false,
			unit_required:false,
			code_required:false,
			component_number: "",
	   		component_id:"",
	   		units_list:[],
	   		unit_check:[],
	   		all_check:false,
	   		
			edition:false,
			component:[],
			place:"",
			places:[],
			reason:"",
			reasons:[],
		}
	}

	componentDidMount(){

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		fetch(Config.default.apiGateway.URL+'lookups?type=place_unit_locked&option=actives&order=true',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				places: response
			});
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=reason_unit_locked&option=actives&order=true',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				reasons: response
			});
		})

		if(this.props.match.params.folio === undefined){
			//Criterio funcional,cambiar lugar de colecta
			fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
				method: 'get',
				headers: new Headers({
					'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then(response => {
				this.setState({
					preview_print: response
				});
			})


		}else{
			this.setState({edition:true});
			this.getList();
		}
					
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_incidents/by_folio?discard_folio='+
				this.props.match.params.folio,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					units_list:response.res
				})
			}
		});
	}

	getOption(option){
		this.setState({
			option:option,
			unit_number:"",
			code_component_list:[],
			code_component:"",
			isLoading:false,
			unit_required:false,
			code_required:false,
			component_number: "",
	   		component_id:"",
	   		units_list:[],
	   		unit_check:[],
	   		all_check:false,
	   		reason_id:""
		});

	}

	getData(result){
		var units = [];
		this.setState({
			unit_check:[],
			units_list:[],
			all_check:false,
		});

		setTimeout(function(){
			result.map((d, i)=>{
				this.setState({
					unit_check: [...this.state.unit_check, {id:d.unit.id, value:d.unit.volume, check:false}],
				});
				units.push(d);
			});

			this.setState({
				units_list: units,							
			});
		}.bind(this), 100);		
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});

		if(e.target.value !== ""){
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500);
		}
	}

	addUnit(e){
		if(this.isValidForm()){

    		if(this.state.component[0].status !== 'RESERVADA' && this.state.component[0].status !== 'BLOQUEADA'){
    			
				
				var index = this.state.units_list.findIndex(obj => obj.unit.id === this.state.component[0].unit.id);

				if(index === -1){
					this.setState({
						units_list: [...this.state.units_list, this.state.component[0]],
						component:[],
						unit_number:"",
						code_component_list:[],
						code_component:"",
					});

					this._typeahead.getInstance().clear();

					document.getElementById('unit_number').focus();
				}else{
					swal('Error', 'La unidad que intenga agregar ya fue agregada a la lista','error');
				}
    		}else{
    			this._typeahead.getInstance().clear();

				document.getElementById('unit_number').focus();
    			swal('Error', 'No es posible dar de baja la unidad y componente, debido a que se encuentra reservada ó bloqueada', 'error');
    		}

		    		


	    	
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	selectComponent(e){
		if(e.key === 'Enter'){
			this.onSearch(e);
			
		}else{
			this.onSearch(e);
		}
	}

	onSearch(e){
		if(e.length > 0){
			this.setState({
	   			isLoading: true,
	   			component:e, 
	   			code_component:e[0].label,

	   		});

	   		setTimeout(function(){
	   			this.setState({isLoading:false});
	   		}.bind(this), 500)
	   	}
	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			fetch(Config.default.apiGateway.URL+'units/get_discard_search?health_facilities_id='+
				sessionStorage.getItem('health_facilities_id')+
				'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						code_component_list:  response,
					});
					this._typeahead.getInstance().clear();
					this._typeahead.getInstance().focus();
					
				}

			})
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	onChecked(e){
		this.state.unit_check.map((u, j)=>{
			return u.id === parseInt(e.target.id) ?
				u.check = u.check ? false : true
			: null
		});
		this.forceUpdate();
	}

	selectAll(e){
		if(e.target.checked){
			this.setState({
				all_check:true
			})
		}else{
			this.setState({
				all_check:false
			})
		}

		this.state.unit_check.map((u, j)=>{
			if(e.target.checked)	
				u.check = true;
			else
				u.check = false;	
			
		});
		this.forceUpdate();
	}

	onSave(){
		if(this.isValidDate(this.state.date)){
			

			if(this.state.reason !== ""){
				document.getElementById('reason').classList.remove('error');
				var incidents = this.getDataForm();

				if(incidents.units.length === 0){
					swal('¡Error!', "No ha seleccionado ninguna unidad", 'error');
				}else if(incidents.reserved !== ''){
					swal('Error', 'No es posible guardar las unidades '+incidents.reserved+' debido a que se encuentran reservadas', 'error');
				}else if(incidents.locked !== ''){
					swal('Error', 'No es posible guardar las unidades '+incidents.locked+' debido a que se encuentran bloqueadas', 'error');
				}else{
					var obj = {
						unit_ids:incidents.units, 
						destination_place:this.state.place,
						reason_to_lock:this.state.reason
					};

					this.waiting_modal.handleShow('Guardando...');
					fetch(Config.default.apiGateway.URL+'units_locked', {
						method: "POST",
						body:JSON.stringify(obj),
						headers: new Headers({
							'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						this.waiting_modal.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then(function(msg){
								swal("Error", msg, 'error');
							});
						}
					}).then(response => {
						if(response !== undefined){
							swal('¡Buen Trabajo!', "Proceso Terminado", 'success');

							if(this.state.option !== 'Unit'){
								//Limpiar componente seleccionado
								this.criterials.setState({blood_component_id:"all"});
								//Recargar componentes
								this.criterials.getBloodComponent('lookups?type=blood_component_type&option=actives&order=true');

							}else{
								this._typeahead.getInstance().clear();
							}
							//this.printFolioPDF(this.state.folio);

							this.setState({
								unit_number:"",
								code_component_list:[],
								code_component:"",
								isLoading:false,
								unit_required:false,
								code_required:false,
								component_number: "",
						   		component_id:"",
						   		units_list:[],
						   		unit_check:[],
						   		all_check:false,
						   		reason:"",
						   		place:""
							});

							this.onReturn();
						}
					});
				}
				
			}else{
				document.getElementById('reason').classList.add('error');
				swal('¡Error!', "Campos incompletos", 'error');
			}
		}else{
			notify.show('Error, Fecha no válida','error');
		}		
	}

	async printFolioPDF(folio){
		this.props.waiting.handleShow('Imprimiendo...');
					
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = folio;
		obj.file_type = "discard_units";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
		}else{
			this.props.waiting.handleClose();
		}
	
		
	}

	directPrint(response, label_type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
		}
	}

	getDataForm(){
		var obj = {};
		var unit_reserved = '';
		var unit_locked = '';

		var units = [];

		this.state.units_list.map((u, i)=>{
			if(this.state.option === "Unit"){
				units.push(u.unit.id);

			}else{
				if(this.state.unit_check[i].check){
					if(u.status === 'RESERVADA'){
						unit_reserved += u.unit.unit_number+' '+
										(u.component_number !== undefined ? u.component_number 
										: u.unit.component_number)+', ';
					}

					if(u.status === 'BLOQUEADA'){
						unit_reserved += u.unit.unit_number+' '+
										(u.component_number !== undefined ? u.component_number 
										: u.unit.component_number)+', ';
					}
					
					units.push(u.unit.id);
								
				}
			}
				
		});
		
		obj = {units:units, reserved:unit_reserved, locked:unit_locked};
		
		return obj;
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	   
    	inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}		   
		  	}
	    });
	    
		    
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		
		return res;
	}

	onReturn(){
		this.props.history.push('/lock_units');
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_incidents/delete_unit?unit_id='+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    }.bind(this));
	}

	deleteFromList(i){
		var array = [...this.state.units_list];
   		array.splice(i, 1);
   		this.setState({units_list: array});
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						Bloqueo de unidades
					</h5>
				</div>
				
				<form noValidate>
					<div className="col-xs-12">

						{!this.state.edition ?
						<fieldset>
							<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
							<div className="col-xs-12 col-sm-1" style={{paddingRight:"0"}}>
								<Options {...this.props} validate={this.validateInput} sendData={this.getOption} 
									onRef={ref => (this.options = ref)} />
							</div>

							<div className="col-xs-12 col-sm-10">
								{this.state.option === 'Block' ?
									<Criterials {...this.props} search={""} validate={this.validateInput} sendData={this.getData} onRef={ref => (this.criterials = ref)} />
								:
									<div className="col-xs-12">
										<div className="col-xs-12 col-sm-3 col-md-2" >
											<span className="span-min">Número de Unidad</span>
											<input type="text" name="unit_number" id="unit_number"  
												onChange={this.handleChange} value={this.state.unit_number || ""} 
												onKeyPress={(e) => this.searchComponent(e)}
												required
												className={this.state.unit_required ? "form-control error" : "form-control"} />
										</div>

										<div className="col-xs-12 col-sm-3 col-md-2" >
											<span className="span-min">Código Componente</span>

											<Typeahead
									          	/*{...this.state}*/
									          	labelKey={(option) => `${option.label}`}
									          	minLength={0}
									          	options={this.state.code_component_list}
									          	onKeyDown={this.selectComponent}
									          	onChange={this.onSearch}
									            inputProps={{
									          		name:"code_component",
									          		required:'required',
									          		id:"code_component"
									          	}}
									          	id="codeComponent"
									          	selectHintOnEnter={true}
									          	isLoading={this.state.isLoading}
									          	ref={ref => this._typeahead = ref}
									          	delay={600}
									          	paginationText="Mostrar mas resultados..."
									        />
										</div>
										
										<div className="col-xs-12 col-sm-1" >
											<button type="button" className="btn btn-info" style={{fontSize:"0.8em", marginTop:"16px"}}
												onClick={this.addUnit}>
												Agregar
											</button>
										</div>
									</div>
								}
							</div>
						</fieldset>
						: null}
							

						<fieldset>
							{!this.state.edition ?
								<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Proceso</legend>
							:null}	
							
							<div className="col-xs-12 col-sm-9 form-group" style={{marginLeft:'13%'}}>
								{this.state.option !== 'Unit' && !this.state.edition?
									<div className="col-xs-12 col-sm-9">
										<input className="form-check-input" name="all"  type="checkbox" type="checkbox" onKeyPress={(e) => this.validateInput(e)} 
											checked={this.state.all_check} onChange={this.selectAll}/>
										<span className="span-min" style={{paddingLeft:"5px"}}>Seleccionar Todos</span>
									</div>
								:null}
								<div className="col-xs-12 form-group">										
									<Table responsive hover>
										<thead>
											<tr>
												<th hidden={this.state.edition}></th>
												<th>No. Unidad</th>
												<th>No. Componente</th>
												<th>Fecha Caducidad</th>
												<th>Componente Sanguíneo</th>
												<th>Grupo y RH</th>
												<th>Volumen</th>
												<th>
													{!this.state.edition ? "Estatus" : ""}
												</th>
												<th hidden={!this.state.edition ? this.state.option !== 'Unit' : true }></th>
												
											</tr>
										</thead>
										<tbody>

										{this.state.units_list.length > 0 ?
											this.state.units_list.map((d, i)=>{
												return <tr key={i}>
													<td hidden={this.state.edition}>
														{this.state.option !== "Unit" ?
															<input type="checkbox" id={d.unit.id}  onChange={this.onChecked} 
																onKeyPress={(e) => this.validateInput(e)}
																checked={this.state.unit_check[i] !== undefined ? this.state.unit_check[i].check : ""}
																value={this.state.unit_check[i] !== undefined ? this.state.unit_check[i].value : ""} />
														:null}
													</td>
													<td>{d.unit.unit_number}</td>
													<td>{d.component_number !== undefined ? d.component_number : d.unit.component_number}</td>
													<td>{moment(d.unit.caducidad).format('DD/MM/YYYY')}</td>
													<td>
													{d.blood_component !== undefined ?
														d.blood_component.component
													:d.component}
													</td>
													<td>{d.unit.group+(d.unit.rh === "POSITIVO" ?'+':'-')}</td>
													<td>{d.unit.volume} ml</td>
													<td>
														{!this.state.edition ? d.status: 
														<Button className="btn btn-info btn-xs" title="Eliminar" 
															style={{marginRight:'3px'}} 
															onClick={this.onDelete.bind(this, d.unit.id)}>
								                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
								                        </Button>
														}
													</td>	
													<td hidden={!this.state.edition ? this.state.option !== 'Unit' : true }>
														<Button className="btn btn-info btn-xs" title="Eliminar" 
															style={{marginRight:'3px'}} 
															onClick={this.deleteFromList.bind(this, i)}>
								                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
								                        </Button>
													</td>												
												</tr>
											})
										:null}
										</tbody>
									</Table>
								</div>	

								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-3" style={{marginLeft:'24%'}}>
										<span>Destino</span>
										<select className="form-control" id="place" name="place"
											value={this.state.place} onChange={this.handleChange}>
											<option value="">Seleccione...</option>
											{this.state.places.map((p, i)=>(
												<option key={i} value={p.key}>
													{p.name}
												</option>
											))}
										</select>
									</div>
									<div className="col-xs-12 col-sm-3">
										<span>Motivo de Bloqueo</span>
										<select className="form-control" id="reason" name="reason"
											value={this.state.reason} onChange={this.handleChange}>
											<option value="">Seleccione...</option>
											{this.state.reasons.map((p, i)=>(
												<option key={i} value={p.key}>
													{p.name}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>
							
							

						</fieldset>

						<div className="col-xs-12" style={{textAlign:'center'}}>
							{!this.state.edition ?
					        	<div>
					        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} style={{margin:12}} onClick={this.onSave} />
					        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
					        	</div>
				        	:<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} primary={true} style={{margin:12}} onClick={this.onReturn} />
				           	</div>}
				        </div>

				        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				        <Notifications />
					</div>
				</form>

			</div>
		)
	}
}

export default translate('translations') (LockUnitsForm)